module.exports = __webpack_public_path__ + "assets/img/experts-4.dc15bd62.png";